module.exports = __webpack_public_path__ + "img/restart.3c8ee48b.png";